import React from 'react';

import { Desktop, Mobile } from 'components/Responsive';

import RegistrationOnboardingDesktopLayout from './RegistrationOnboardingDesktopLayout';
import RegistrationOnboardingMobileLayout from './RegistrationOnboardingMobileLayout';

export interface RegistrationOnboardingLayoutProps {
  children: any;
  current?: string;
  sideAssetUrl?: string;
  totalSteps?: 3 | 4;
  currentStep?: 0 | 1 | 2 | 3;
  noGoBack?: boolean;
  appBarTitle?: string;
  onGoBack?: () => void;
}

const RegistrationOnboardingLayout = (props: RegistrationOnboardingLayoutProps) => (
  <>
    <Desktop>
      <RegistrationOnboardingDesktopLayout {...props} />
    </Desktop>
    <Mobile>
      <RegistrationOnboardingMobileLayout {...props} />
    </Mobile>
  </>
);

export default RegistrationOnboardingLayout;
